/**
 * Created by vadimdez on 29/02/16.
 */
export default class Teleport {
    constructor(map) {
        this.map = map
    }
}


// WEBPACK FOOTER //
// ./Entities/Teleport.js